import { LevelOperatorType } from './LevelOperatorType';

export const LevelOperatorTypeOptions = [
    {
        id: LevelOperatorType.EqualTo,
        name: 'Equal To',
    },
    {
        id: LevelOperatorType.GreaterThan,
        name: 'Is Greater Than',
    },
    {
        id: LevelOperatorType.GreaterThanOrEqualTo,
        name: 'Is Greater Than Or Equal To',
    },
    {
        id: LevelOperatorType.LessThan,
        name: 'Is Less Than',
    },
    {
        id: LevelOperatorType.LessThanOrEqualTo,
        name: 'Is Less Than Or Equal To',
    },
];
